import React, { useState, useEffect } from 'react';

// Local veri
const initData = {
    heading: "Socia İle Neler Yapabilirsin?",
    thumbOne: "/img/Home.png",
};

// Local servis verileri
const serviceData = [
    {
        id: 1,
        iconClass: "fab fa-buffer",
        text: "Şehrindeki en özel etkinlikleri tek bir yerde keşfedebilirsin"
    },
    {
        id: 2,
        iconClass: "fas fa-brush",
        text: "İlgi alanlarına göre kişiselleştirilmiş öneriler alabilirsin"
    },
    {
        id: 3,
        iconClass: "fas fa-burn",
        text: "Farklı etkinlik türlerine göz atıp, favorilerini belirleyebilirsin"
    },
    {
        id: 4,
        iconClass: "fas fa-cart-arrow-down",
        text: "Favori organizatörleri takip ederek yeni etkinliklerden haberdar olabilirsin"
    },
    {
        id: 5,
        iconClass: "fas fa-cart-arrow-down",
        text: "Katıldığın etkinlikleri arşivle ve anılarını profilinde sakla"
    }
];

const ServiceSection = () => {
    const [data, setData] = useState({});
    const [services, setServices] = useState([]);

    useEffect(() => {
        // API yerine yerel sabitlerden veri ayarlama
        setData(initData);
        setServices(serviceData);
    }, []);

    return (
        <section 
            className="section service-area overflow-hidden ptb_100"
            style={{ 
                background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                color: 'white'
            }}
        >
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-12 col-lg-6 order-2 order-lg-1">
                        {/* Service Text */}
                        <div className="service-text pt-4 pt-lg-0">
                            <h2 className="text-capitalize mb-4" style={{ color: 'white' }}>{data.heading}</h2>
                            {/* Service List */}
                            <ul className="service-list">
                                {services.map((item, idx) => (
                                    <li key={`so_${idx}`} className="single-service media py-2">
                                        <div className="service-icon pr-4">
                                            <span><i className={item.iconClass} style={{ color: '#a074f7' }} /></span>
                                        </div>
                                        <div className="service-text media-body">
                                            <p style={{ color: 'white' }}>{item.text}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 order-1 order-lg-2 d-none d-lg-block">
                        {/* Service Thumb */}
                        <div className="service-thumb mx-auto">
                            <img src={data.thumbOne} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSection;